import { FC } from 'react';

import { GridPaginationModel } from '@thirdspacelearning/library';

import { getFiltersMap } from '../utils';

import { useCurriculumYears } from '@hooks';
import { Filters } from '@shared';
import { Country, LearningObjectiveType, SearchParams, Year } from '@types';

interface Props {
    years: Year[];
    searchParams: SearchParams;
    setSearchParams: (params: SearchParams) => void;
    paginationModel: GridPaginationModel;
    setPaginationModel: (paginationModel: GridPaginationModel) => void;
    country: Country;
}

const LearningObjectivesFilters: FC<Props> = ({
    years,
    searchParams,
    setSearchParams,
    paginationModel,
    setPaginationModel,
    country,
}) => {
    const { yearsMap } = useCurriculumYears(years);

    const filtersMap: Record<Country, any> = getFiltersMap(
        searchParams.objective_type as LearningObjectiveType,
        yearsMap,
        years,
    );

    const filters = filtersMap[country];

    return (
        <Filters
            key={'filters'}
            filters={filters}
            searchParams={searchParams}
            setSearchParams={setSearchParams}
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            resetFiltersOn={country}
            resetAdditionalParams={{
                objective_type:
                    country === Country.GB
                        ? LearningObjectiveType.STANDARD
                        : '',
            }}
        />
    );
};

export default LearningObjectivesFilters;
